import { ShoppingCart } from 'lucide-react'

import { Button } from '@/components/ui/button'

/**
 * Nav cart entry point with a count badge. Shows the badge only once at least one
 * coverage has been added. Used on the Quotes page nav and on the insurance tab.
 */
export function NavCartButton({ count, onClick }: { count: number; onClick?: () => void }) {
  return (
    <Button
      type="button"
      variant="ghost"
      size="icon-sm"
      onClick={onClick}
      aria-label={count > 0 ? `Cart, ${count} ${count === 1 ? 'coverage' : 'coverages'}` : 'Cart, empty'}
      className="relative rounded-full"
    >
      <ShoppingCart />
      {count > 0 && (
        <span className="bg-ink-900 absolute -top-1 -right-1 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[10px] leading-none font-bold text-white">
          {count}
        </span>
      )}
    </Button>
  )
}
